import type { DescriptorDatatype, Graph } from "@lr-notitia/notitia-operator/schemas";
import { Ref, computed } from "vue";
import { useSymbolsStore } from "../symbols";

let symbolsStore: ReturnType<typeof useSymbolsStore>;
function init() {
	symbolsStore = useSymbolsStore();
}

export const datatypes = (graph: Ref<Graph>) =>
	computed<DescriptorDatatype[]>(() => {
		if (!symbolsStore) init();
		return (
			Object.values(graph.value.nodes).filter((node) => node.type === "datatype") as DescriptorDatatype[]
		).sort((a, b) =>
			symbolsStore
				.term({ id: a.refersTo, terminology: a.terminology })
				.toLocaleLowerCase()
				.localeCompare(symbolsStore.term({ id: b.refersTo, terminology: b.terminology }).toLocaleLowerCase())
		);
	});
export function datatype(domainId: Ref<string>, graph: Ref<Graph>) {
	return {
		byId: (id: string) => graph.value.nodes[id] as DescriptorDatatype | undefined,
	};
}
